<template>
<div>
  <div class="homepage__slider__background--large" :style="`background-image: url('${currentVideo.bgURL}')`"></div>
  <div class="homepage__play-video" @click="openVideo(currentVideo)"><img class="homepage__play-video__icon" src="../../assets/play-button.svg">Play</div>
  <div class="homepage__description">
    <div class="logos">
      <div class="logo">
        <a href="https://www.bfna.org/" target="_blank" rel="noopener"><img src="../../assets/bertelsmann-logo.png" width="128"/></a>
      </div>
      <div class="logo">
        <a href="https://www.humanityinaction.org/" target="_blank" rel="noopener"><img src="../../assets/HIA_Logo-white.png" width="128"/></a>
      </div>
    </div>
    <div class="video-description" v-show="hasVideos">
      <div class="video-description__author-wrapper">
        <div class="video-description__author" :style="{ backgroundImage: `url('${getAuthorPicture(currentVideo)}')` }"></div>
      </div>
      <div class="video-description__description">
        <ul class="video-description__tabs tabs">
          <li class="tabs__item"><a href="#" class="tabs__link" :class="{ 'active' : selectedTab == 'desc' }" @click.prevent="selectedTab='desc'">Description</a></li>
          <li class="tabs__item"><a href="#" class="tabs__link" :class="{ 'active' : selectedTab == 'bio' }" @click.prevent="selectedTab='bio'">Bio</a></li>
        </ul>
        <perfect-scrollbar class="video-description__text" v-if="selectedTab == 'desc'">
          {{ currentVideo.description }}
        </perfect-scrollbar>
        <perfect-scrollbar class="video-description__text" v-else>
          {{ currentVideo.bio }}
        </perfect-scrollbar>
        <p>
          <b class="podcast-icon" style="cursor:pointer;" title="Suggested tweet" @click="openSuggestedTweet" target="_blank" rel="noopener" v-if="currentVideo.suggestedTweet">
            <img alt="Suggested tweet" src="/img/icons/twitter.svg" />
          </b>
          <a class="podcast-icon" :href="currentVideo.googlePodcastsUrl" title="Google Podcasts" target="_blank" rel="noopener" v-if="currentVideo.googlePodcastsUrl">
            <img alt="Google Podcasts" src="/img/icons/google-podcasts.svg" />
          </a>
          <a class="podcast-icon" :href="currentVideo.itunesUrl" title="iTunes" target="_blank" rel="noopener" v-if="currentVideo.itunesUrl">
            <img alt="iTunes" src="/img/icons/podcasts.svg" />
          </a>
          <a class="podcast-icon" :href="currentVideo.spotifyUrl" title="Spotify" target="_blank" rel="noopener" v-if="currentVideo.spotifyUrl">
            <img alt="Spotify" src="/img/icons/spotify.svg" />
          </a>
        </p>
      </div>
    </div>
  </div>
</div>
</template>

<style lang="scss" scoped>
.homepage__slider__background--large {
  position: absolute;
  z-index: -1;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: #000000;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  // opacity: 0.67;
}
.homepage {
  &__play-video {
    z-index: 11;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    text-align: center;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 2.125em;
    color: #ffffff;
    padding: 16px 0;
    cursor: pointer;
    user-select: none;
  }

  &__description {
    position: absolute;
    left: 0;
    bottom: 0;
    display: flex;
    align-items: flex-end;
    width: 100vw;
    height: 352px;
    padding: 0 80px 64px 80px;
  }
}

.video-description {
  flex: initial;
  height: 40vh;
  width: calc(50vw + 12.5px);
  display: flex;
  padding-left: 32px;
  align-items: flex-end;

  &__description {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    margin: 0 20px 32px 20px;
    color: #ffffff;
    font-size: 1em;
    font-weight: 300;
    line-height: 24px;
    text-align: left;
    p {
      margin-bottom: 0;
    }

    @media (min-width: 100em) {
      justify-content: flex-start;
    }
  }

  &__text {
    margin-bottom: 20px;
    height: 20vh;
  }

  &__author-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    flex: 0;
    padding: 25px 0 32px 0;

    @media (min-width: 100em) {
      flex-direction: column;
      padding: 48px 0 0 0;
    }
  }

  &__author {
    width: 125px;
    height: 125px;
    border-radius: 50%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
  }

  @include media-breakpoint-large {
    //flex: 2;

    &__description {
      margin: 0 20px 32px 20px;
      font-size: 1.25em;
      line-height: 32px;
    }
  }

  @include media-breakpoint-x-large {
    //flex: 1;

    &__description {
      margin: 0 20px 32px 48px;
    }
  }
}

.logos {
  flex: 1;
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  flex-direction: column;
  padding: 32px
}

.logo {
  flex: 0;

  & + & {
    margin-top: 32px;
  }
}

.podcast-icon {
  display: inline-block;

  & + & {
    margin-left: 16px;
  }
}

.tabs {
  list-style: none;
  display: flex;
  flex-flow: row nowrap;
  gap: 32px;
  padding: 0;
  margin-bottom: 20px;
  height: 25px;
}

  .tabs__link {
    font-size: 1.25em;
    font-weight: 700;
    display: block;
    line-height: 1em;
    text-transform: uppercase;
    color: #FFF;

    &:hover,
    &:visited,
    &:focus,
    &:active {
      text-decoration: none;
    }

    &:hover,
    &:focus,
    &.active {
      color: #FC8B00;
    }
  }

</style>

<script>
import utils from '../../utils'
import { PerfectScrollbar } from 'vue2-perfect-scrollbar'

export default {
  components: { PerfectScrollbar },
  data () {
    return {
      selectedTab: 'desc'
    }
  },
  computed: {
    hasVideos () {
      return this.$store.getters.hasVideos
    },
    currentVideo () {
      return this.hasVideos ? this.$store.state.videoList[this.$store.state.currentVideo] : this.$store.getters.emptyEpisode
    }
  },
  methods: {
    openVideo (video) {
      const videoId = utils.getVideoIdFromYoutubeUrl(video.videoUrl)
      if (!videoId) {
        alert(`Couldn't play video:\nvideo ID not found in "${video.videoUrl}".`)
      }
      this.$store.commit('setHomepageVideoEffect', true)
      setTimeout(() => {
        this.$router.push({ name: 'watchVideoId', params: { videoId } })
      }, 330)
    },
    getAuthorPicture (episode) {
      if (this.hasVideos && episode.authors.length > 0) {
        return episode.authors[0].picture.url
      } else {
        return ''
      }
    },
    openSuggestedTweet () {
      this.$store.commit('setSuggestedTweetHomepageVisibility', true)
    }
  }
}
</script>
